module.exports = __webpack_public_path__ + "media/images/riders/LARS_FORSTER-66eb51c0d63edab6c25642d8d13cb258.png";